import { createFileRoute, notFound } from "@tanstack/react-router";
import compareStyles from "../styles/compare.css?url";
import useCaseStyles from "../styles/use-cases.css?url";
import { withStylesheet } from "../lib/head";
import { platformPageHead, platformShellFrom } from "../platform/head";
import { loadUseCase } from "../platform/use-cases";
import { UseCasePage } from "../platform/use-cases/use-case-pages";

/** One template's page (/use-cases/<slug>), on Drate's host only. */
export const Route = createFileRoute("/use-cases/$slug")({
  loader: async ({ params }) => {
    const page = await loadUseCase({ data: params.slug });
    if (!page) throw notFound();
    return page;
  },
  head: ({ matches, loaderData, match }) =>
    loaderData
      ? withStylesheet(
          withStylesheet(
            platformPageHead(platformShellFrom(matches), {
              pathname: match.pathname,
              title: loaderData.title,
              description: loaderData.description,
              structuredData: loaderData.structuredData,
            }),
            compareStyles,
          ),
          useCaseStyles,
        )
      : {},
  component: () => <UseCasePage page={Route.useLoaderData()} />,
});
